import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestroyableComponent } from '../../classes/destroyable.component';
import { interval } from 'rxjs';
import { MemoryMonitorService } from '../../services/memory-monitor.service';

@Component({
  selector: 'app-memory-debug',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed bottom-4 right-4 bg-gray-900 text-white p-4 rounded-lg shadow-lg text-xs font-mono z-[9999]">
      <div class="font-bold mb-2">🧠 Memory Monitor</div>
      <div>Current: {{ report.current.toFixed(2) }} MB</div>
      <div>Average: {{ report.average.toFixed(2) }} MB</div>
      <div [class]="report.trend > 10 ? 'text-red-400' : 'text-green-400'">
        Trend: {{ report.trend > 0 ? '+' : '' }}{{ report.trend.toFixed(2) }} MB
      </div>
      @if (report.trend > 20) {
        <div class="text-red-400 mt-2 font-bold">⚠️ Leak Detected!</div>
      }
    </div>
  `
})
export class MemoryDebugComponent extends DestroyableComponent implements OnInit {
  report = { current: 0, average: 0, trend: 0 };

  constructor(private memoryMonitor: MemoryMonitorService) {
    super();
  }

  ngOnInit(): void {
    this.subscribe(interval(1000), () => {
      this.report = this.memoryMonitor.getReport();
    });
  }
}